import React from 'react'
import useTrans from '../../../../../hooks/useTrans'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import { useSelector } from 'react-redux'
import { Button } from '../../../../atoms'
import { getTipologieUtenteRegistrazione } from '../../../../../utils/servicegift'

const TipologiaUtente = ({ props, setStep, step, setTipologiaUtente }) => {
  const { service_gift } = useSelector((state) => state?.servicegift)
  const t = useTrans()

  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets"></div>
      <p className="step-registrazione__legend"></p>

      <div className="step-registrazione__tipologia-utente__options">
        {getTipologieUtenteRegistrazione(service_gift)?.map((x) => (
          <div
            className={`step-registrazione__tipologia-utente__option ${
              props.values.utente.tipologia === x.chiave &&
              'step-registrazione__tipologia-utente__option--active'
            }`}
            onClick={() => {
              // se diverso => reset step successivi
              if (props.values.utente.tipologia != x.chiave) {
                props.resetForm()
              }

              setTipologiaUtente(x.chiave)
              props.setFieldValue('utente.tipologia', x.chiave)
            }}
          >
            <FormRadio
              size="sm"
              label={t(x.titolo)}
              checked={props.values.utente.tipologia === x.chiave ? true : false}
              id={`tipologia-utente-${x.chiave}`}
            />
          </div>
        ))}
      </div>

      <Button
        label={t('Conferma dati')}
        variant="primary"
        size="medium"
        onClick={() => setStep(step + 1)}
      />
    </div>
  )
}

export default TipologiaUtente
